const translation = {
    // Langs (Keep them like this, as they are used in the language switcher)
    'English': 'English',
    'Français': 'Français',
    'Español': 'Español',
    
    // NAVIGATION
    'Inicio': 'Home',
    'Nuestro menú': 'Our menu',
    'Procesando': 'Processing',
    'Nombre' : 'Name',
    'Nombres' : 'Names',
    'Nombre completo': 'Full name',
    'Apellidos' : 'Last name',
    'Correo electrónico' : 'E-mail',
    'Teléfono' : 'Phone',
    'Telefono' : 'Phone',
    'Imagen' : 'Image',
    'Imágen' : 'Image',
    'Mensaje' : 'Message',
    'Nuevo' : 'New',
    'Editar' : 'Edit',
    'Departamento' : 'Admin. role',
    "Justo ahora" : 'Just now',
    "Actualizar perfil" : 'Update profile',
    "Mi cuenta" : 'My account',
    'Cerrar sesión' : 'Log out',
    "Para continuar, llena los datos requeridos": 'To continue, fill all the required inputs',
    "Lista vacía": 'Empty list',
    "Intenta agregando un elemento con las herramientas de arriba": 'Try adding an item with the tools above',
    'min_read': 'min. read',

    'Atrás' : 'Back',
    'Adelante' : 'Next',

    'logout_ask': 'Are you sure you want to log out and exit?',
    'logout_confirmButtonText': 'End session',
    'logout_cancelButtonText': 'Cancel',
    'logout_title': 'See you soon!',
    'logout_logout': 'Your session has been terminated.',
    
    'Cancelar': 'Cancel',
    'Continuar': 'Continue',
    'Cerrar': 'Close',
    'Borrar': 'Delete',
    "Guardar": 'Save',
    '¿Seguro que deseas continuar?': 'Are you sure you want to continue?',
    "Esta acción no se puede deshacer": 'This action can\'t be undone',

    'Contraseña' : 'Password',
    'i_agree_to_the': 'I agree to the',
    '_and_': 'and the',

    // DOMICILIO DETAILS FORM
    'Domicilio': 'Address',
    'Domicilios': 'Address',
    'ubicacion': 'Location',
    'email': 'E-mail',
    'Calle': 'Street',
    'Número exterior': 'Ext. number',
    'Número interior': 'Int. number',
    'Estado': 'State',
    'Municipio': 'municipality',
    'Colonia': 'Colony',
    'Código postal': 'Zip',
    'Referencias de la ubicación (opcional)': 'Location references (optional)',
    'Hotel, villa o condominio de referencia': 'Hotel, villa or condo of reference.',
    'P. e. Frente al parque.': 'e.g. In front of the park.',
    'Datos del cliente': 'Client´s data',
    'Teléfono celular': 'Phone number',
    'Fecha y hora': 'Schedule',
    'Comentarios del pedido': 'Order comments',
    'P. e. No nos gusta el picante, alergias, etc...': 'P. e. Not spicy meals, allergies, etc...',
    'zona': 'Zone',

    // HELPERS
    'Mas información': 'More information',
    'Enviar': 'Send',
    'Imprimir': 'Print',
    'stripePagosId': 'Stripe payment ID',
    'call_to_action': 'Book now!',

    // FOOTER
    'Nuestros servicios': 'Our services',
    'Todos los derechos reservados.': 'All rights reserved.',

    // MINOR DETAILS
    'nombres': 'Full name',
    'telefono_celular': 'Phone',
    'created': 'Creation date',
    'modified': 'Latest update',

    // PEDIDO
    'folio': 'Invoice',
    'estatus': 'Status',
    'agenda_inicio': 'Schedule',
    'pedidoTipo': 'Order type',
    'personas': 'Persons',
    'origenInsumos': 'Origin of inputs',
    'FullAddress': 'Address',
    'comentarios_cliente': 'Client\'s comments'
}

export {translation};
